module.exports = __webpack_public_path__ + "static/media/herramienta-gris.ef4f891a.svg";